<h2>Access Denied</h2>

<div class="content">
  <span><span class="glyph glyph-spam"></span>You do not have access to this product.</span>
</div>

<div class="actions">
  <button  mat-button mat-dialog-close (click)="close()">OK</button>
</div>
